/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */
import { notification } from "antd";
import { getData } from "./api/Interface";
import { SchoolManagerAPIRoutes } from "./api/APIRoutes";
import moment from "moment-jalaali";

export const authenticatedUserDataSetter = async (obj) => {
  await localStorage.setItem("zibatran-user-data", JSON.stringify(obj));
};

export const logoutUser = async () => {
  getData(SchoolManagerAPIRoutes.UnAuth);
  await localStorage.clear();
  window.location = "/auth";
};

export const openNotificationWithIcon = (type, title, description, id) => {
  notification[type]({
    message: title,
    key: id,
    description: description,
    // duration: 1000000,
  });
};

export const getCustomFormat = (inputValue, isGregorian) => {
  if (!inputValue) return "";
  const inputFormat = isGregorian
    ? "YYYY/M/D HH:mm:ss"
    : "jYYYY/jM/jD HH:mm:ss";
  return isGregorian
    ? inputValue.locale("es").format(inputFormat)
    : inputValue.locale("fa").format(inputFormat);
};

export function getFormattedDate(date, time) {
  let yyy = date.getFullYear();
  let mm = date.getMonth() + 1;
  let dd = date.getDate();
  let hour = time.getHours();
  let min = time.getMinutes();
  let sec = time.getSeconds();

  return new Date(
    yyy + "/" + mm + "/" + dd + " " + hour + ":" + min + ":" + sec
  );
}

export function timeUnixToNormal(timeUnix) {
  const jalaliDate = moment.unix(timeUnix).format("jYYYY/jM/jD HH:mm");
  return jalaliDate;
}

export function utcTimeToNormal(utcTime) {
  const jalaliDate = moment
    .utc(utcTime)
    .utcOffset(3.5)
    .local("Asia/Tehran")
    .format("jYYYY/jM/jD HH:mm");
  return jalaliDate;
}
